"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=configuration.interface.js.map